export enum Feature {
  // 미팅
  MEETING_ARCHIVE = 'meeting_archive',
  MEETING_ACCESS_CHANGE = 'meeting_access_change',
  MEETING_TITLE_CHANGE = 'meeting_title_change',
  MEETING_SHARE_SET = 'meeting_share_set',
  MEETING_PROTECT = 'meeting_protect',
  MEETING_DELETE = 'meeting_delete',
  MEETING_DIALOG_EDIT = 'meeting_dialog_edit',
  MEETING_BOOKMARK_CHANGE = 'meeting_bookmark_change',
  MEETING_LABEL_CHANGE = 'meeting_label_change',
  MEETING_SUMMARY_EDIT = 'meeting_summary_edit',
  MEETING_LANGUAGE_RESET = 'meeting_language_reset',
  MEETING_DOWNLOAD_MP4 = 'meeting_download_mp4',
  MEETING_INSIGHT_TRANSLATION = 'meeting_insight_translation',
  MEETING_PARTICIPANT_NAME_CHANGE = 'meeting_participant_name_change',
  MEETING_EXPORT_SALESFORCE = 'meeting_export_salesforce',
  MEETING_EXPORT_PIPEDRIVE = 'meeting_export_pipedrive',
  MEETING_EXPORT_SLACK = 'meeting_export_slack',
  MEETING_EXPORT_NOTION = 'meeting_export_notion',
  MEETING_EXPORT_TEAMS = 'meeting_export_teams',
  MEETING_EXPORT_CONFLUENCE = 'meeting_export_confluence',
  MEETING_EXPORT_EMAIL = 'meeting_export_email',
  MEETING_VIEW = 'meeting_view',
  MEETING_CHAT = 'meeting_chat',
  MEETING_EDIT_CUSTOM_INSIGHT = 'meeting_edit_custom_insight',

  // 모든팀에 추가하는 Feature 만들기
  ALL_TEAM_ACCESS = 'all_team_access',
  ALL_MEETING_ARCHIVE = 'all_meeting_archive',
  MEETING_DELETE_FROM_TEAM = 'meeting_delete_from_team',

  // 예정 미팅
  SCHEDULED_MEETING_VIEW = 'scheduled_meeting_view', //x
  SCHEDULED_MEETING_STATUS_VIEW = 'scheduled_meeting_status_view', //x
  SCHEDULED_MEETING_STATUS_CHANGE = 'scheduled_meeting_status_change', //x
  SCHEDULED_MEETING_LANGUAGE_VIEW = 'scheduled_meeting_language_view', //x
  SCHEDULED_MEETING_LANGUAGE_CHANGE = 'scheduled_meeting_language_change', //x

  // 공유한 미팅
  SHARED_MEETING_VIEW = 'shared_meeting_view', //x
  SHARED_MEETING_ACCESS_CHANGE = 'shared_meeting_access_change', //x

  // 워크스페이스
  WORKSPACE_NAME_CHANGE = 'workspace_name_change',
  WORKSPACE_EMAIL_CHANGE = 'workspace_email_change',
  WORKSPACE_COLOR_CHANGE = 'workspace_color_change',
  WORKSPACE_SCOPE_CHANGE = 'workspace_scope_change',
  WORKSPACE_MEETING_FILTER_ADD = 'workspace_meeting_filter_add',
  WORKSPACE_MEETING_FILTER_DELETE = 'workspace_meeting_filter_delete',
  WORKSPACE_MEETING_LANGUAGE_CHANGE = 'workspace_meeting_language_change',
  WORKSPACE_LABEL_CREATE = 'workspace_label_create',
  WORKSPACE_LABEL_EDIT = 'workspace_label_edit',
  WORKSPACE_LABEL_DELETE = 'workspace_label_delete',
  WORKSPACE_USER_ADD = 'workspace_user_add',
  WORKSPACE_USER_ROLE_EDIT = 'workspace_user_role_edit',
  WORKSPACE_TEAM_CREATE = 'workspace_team_create',
  WORKSPACE_TEAM_EDIT = 'workspace_team_edit',
  WORKSPACE_TEAM_MEMBER_VIEW = 'workspace_team_member_view',
  WORKSPACE_INVITEE_VIEW = 'workspace_invitee_view',
  WORKSPACE_JOIN_REQUEST_VIEW = 'workspace_join_request_view',
  WORKSPACE_TEAM_MEMBER_ADD = 'workspace_team_member_add',
  WORKSPACE_TEAM_MEMBER_DELETE = 'workspace_team_member_delete',

  WORKSPACE_KEYWORDS_VIEW = 'workspace_keywords_view',
  WORKSPACE_KEYWORDS_EDIT = 'workspace_keywords_edit',
  WORKSPACE_LIFECYCLE_CHANGE = 'workspace_lifecycle_change',
  WORKSPACE_TWO_FACTOR_CHANGE = 'workspace_two_factor_change',
  WORKSPACE_ACCESS_RULE_CHANGE = 'workspace_access_rule_change',
  WORKSPACE_SAVE_MEDIA_CHANGE = 'workspace_save_media_change',
  WORKSPACE_SAVE_DIALOG_CHANGE = 'workspace_save_dialog_change',
  WORKSPACE_SAML_CONFIG = 'workspace_saml_config',
  WORKSPACE_SCIM_CONFIG = 'workspace_scim_config',
  WORKSPACE_RECORD_DELETE_SETTINGS_CHANGE = 'workspace_record_delete_settings_change',
  WORKSPACE_MAX_DEVICE_SESSION_COUNT_CHANGE = 'workspace_max_device_session_count_change',
  // 라이센스
  LICENSE_PLAN_VIEW = 'license_plan_view',
  LICENSE_CARD_REGISTER = 'license_card_register',
  LICENSE_CARD_DELETE = 'license_card_delete',
  LICENSE_PLAN_CHANGE = 'license_plan_change',
  LICENSE_PAYMENT_MANAGEMENT = 'license_payment_management',
  LICENSE_PAYMENT_HISTORY_VIEW = 'license_payment_history_view',
  // 로그
  AUDIT_LOGS_VIEW = 'audit_logs_view',
  // 연동
  INTEGRATION_CALENDAR_GOOGLE = 'integration_calendar_google',
  INTEGRATION_CALENDAR_OUTLOOK = 'integration_calendar_outlook',
  INTEGRATION_SLACK_UNFURL = 'integration_slack_unfurl',
  INTEGRATION_CRM_SALESFORCE = 'integration_crm_salesforce',
  INTEGRATION_CRM_PIPEDRIVE = 'integration_crm_pipedrive',
  INTEGRATION_ZAPIER = 'integration_zapier',
  INTEGRATION_NOTION = 'integration_notion',
  INTEGRATION_LINEAR = 'integration_linear',
  INTEGRATION_TEAMS = 'integration_teams',
  INTEGRATION_CONFLUENCE = 'integration_confluence',

  // 자동화
  AUTOMATION_SLACK_CHANNEL = 'automation_slack_channel',
  AUTOMATION_SLACK_CHANNEL_FOR_TEAM = 'automation_slack_channel_for_team',
}
